__turbopack_context__.v({
  "cell": "akDawq_cell",
  "combo-field": "akDawq_combo-field",
  "form": "akDawq_form",
  "header-text": "akDawq_header-text",
  "modal": "akDawq_modal",
  "modal-trigger": "akDawq_modal-trigger",
  "range": "akDawq_range",
  "risk": "akDawq_risk",
  "roi-table": "akDawq_roi-table",
  "row": "akDawq_row",
  "row-header-cell": "akDawq_row-header-cell",
  "shares": "akDawq_shares",
  "total": "akDawq_total",
});
